import * as React from "react";
import { Modal } from "react-bootstrap";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coy as syntaxStyle } from "react-syntax-highlighter/dist/cjs/styles/prism";
import { StringUtils, Language } from "./StringUtils";

interface Props {
    show: boolean;
    heading: string;
    data?: string;
    onClose: () => void;
    autoFormat?: boolean;
}

interface State {
    formattedData?: string;
    language?: Language;
}

export class DataModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            formattedData: props.data ?? "",
            language: "text",
        };
    }

    componentDidMount() {
        this.formatDataIfNeeded();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.data !== this.props.data || prevProps.autoFormat !== this.props.autoFormat) {
            this.formatDataIfNeeded();
        }
    }

    private formatDataIfNeeded() {
        const { data = "", autoFormat } = this.props;
        let formatted = data;
        let language: Language = "text";

        if (!data) {
            formatted = "";
        } else if (autoFormat) {
            try {
                const res = StringUtils.formatData(data);
                formatted = res.formattedData;
                language = res.language;
            } catch {
                formatted = data;
                language = "text";
            }
        }

        if (this.state.formattedData !== formatted || this.state.language !== language) {
            this.setState({ formattedData: formatted, language });
        }
    }

    render() {
        const { show, heading, onClose } = this.props;
        const { formattedData, language } = this.state;

        return (
            <Modal dialogClassName="modal-lg" show={show} onHide={onClose} aria-labelledby="contained-modal-title">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title">{heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formattedData ? (
                        <SyntaxHighlighter language={language} style={syntaxStyle} wrapLines showLineNumbers>
                            {formattedData}
                        </SyntaxHighlighter>
                    ) : (
                        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>No data</pre>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <button type="button" className="btn btn-primary" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}